import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
@Component({
    templateUrl: './app-adyen-payment.component.html'
})
export class AppAdyenPaymentComponent extends BaseComponent implements OnInit, OnDestroy {
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        private route: ActivatedRoute
    ) {
        super();
    }

    ngOnInit() {
        this.renderer.addClass(this.document.body, 'hide-header-footer');

        const script = this.renderer.createElement('script');
        script.src = 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.23.0/adyen.js';
        script.integrity = `sha384-8mwva0PVlFlbNW204liDWLdWflXZVxk84ytAly86gczDok13tfs5q58WGQ7ROWZw`;
        script.crossOrigin = 'anonymous';

        this.renderer.appendChild(this.document.head, script);

        this.route.queryParams.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            const sessionId = params['sessionId'];
            const redirectResult = params['redirectResult'];

            if (sessionId && redirectResult) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error - ReactNativeWebView is injected by React Native app
                window.ReactNativeWebView.postMessage(JSON.stringify({ sessionId, redirectResult }));
            }
        });
    }
}
